import UiModal from '../../../../js/components/UiModal/UiModal'
import { createElement, render } from '../../../../js/utils/render'
import { Slider } from '../../../../js/components/Slider/Slider'
import { isTouchDevice } from '../../../../js/utils/is-touch-device'

const getMentorModalTemplate = (blockName) => {
  return (
    `<div class="mentor-v3-modal__slider" data-slider-name="${blockName} stories">
      <div class="mentor-v3-modal__pagination"></div>
      <ul class="mentor-v3-modal__list"></ul>
    </div>`
  )
}

export class MentorModal extends UiModal {
  constructor(elements, index, blockName) {
    const template = createElement(getMentorModalTemplate(blockName))

    super(template, {
      wrapperClass: 'mentor-v3-modal',
      blockTriggerName: blockName
    })

    this.elements = elements
    this.index = index
    this.slider = null
    this.listElement =  null

    this.stopSliderHandler = this.stopSliderHandler.bind(this)
    this.startSliderHandler = this.startSliderHandler.bind(this)
    this.sliderClickHandler = this.sliderClickHandler.bind(this)
  }

  beforeMounted() {
    this.listElement =  this.element.querySelector('.mentor-v3-modal__list')

    this.renderItems()
  }

  mounted() {
    super.mounted()
    this.initSlider()

    if (isTouchDevice()) {
      this.contentWrapper.addEventListener('touchstart', this.stopSliderHandler)
      this.contentWrapper.addEventListener('touchend', this.startSliderHandler)
    } else {
      this.contentWrapper.addEventListener('mouseenter', this.stopSliderHandler)
      this.contentWrapper.addEventListener('mouseleave', this.startSliderHandler)
    }

    this.listElement.addEventListener('click', this.sliderClickHandler)

    window.$analytics?.push('mentor-click-card', { id: this.index })
  }

  unmounted() {
    super.unmounted()
    window.$analytics?.push('mentor-close-modal', { id: this.slider?.slider?.activeIndex })

    this.slider?.destroy()

    if (isTouchDevice()) {
      this.contentWrapper.removeEventListener('touchstart', this.stopSliderHandler)
      this.contentWrapper.removeEventListener('touchend', this.startSliderHandler)
    } else {
      this.contentWrapper.removeEventListener('mouseenter', this.stopSliderHandler)
      this.contentWrapper.removeEventListener('mouseleave', this.startSliderHandler)
    }

    this.listElement.removeEventListener('click', this.sliderClickHandler)

    // TODO: после закрытия модалки слайдер плохо строллится на андроеде из-за фокуса
    document.activeElement.blur()
  }

  renderItems() {
    const fragment = document.createDocumentFragment()

    this.elements.forEach((el) => {
      const item = createElement(`<li class="mentor-v3-modal__item ui-typography-group"></li>`)
      render(item, el.cloneNode(true))
      render(fragment, item)
    })

    render(this.listElement, fragment)
  }

  initSlider() {
    const wrapper = this.element.querySelector('.mentor-v3-modal__slider')
    const slides = wrapper.querySelectorAll('.mentor-v3-modal__item')
    const isInit = slides.length > 1

    const options= {
      wrapper,
      settings: {
        slidesPerView: 1,
        loop: true,

        effect: 'fade',
        fadeEffect: {
          crossFade: false
        },
        slideClass: 'mentor-v3-modal__item',
        wrapperClass: 'mentor-v3-modal__list',

        pagination: {
          el: '.mentor-v3-modal__pagination',
          type: 'bullets',
          bulletActiveClass: 'mentor-v3-modal__bullet--active',
          bulletClass: 'mentor-v3-modal__bullet',
          bulletElement: 'button',
          clickable: true
        },

        speed: 200,
        autoplay: {
          delay: 10000,
          disableOnInteraction: false
        }
      },
      modules: ['pagination', 'effectFade', 'autoplay'],
      initCondition: {
        sm: isInit,
        md: isInit,
        lg: false,
        xl: false
      }
    }

    this.slider = new Slider(options)
    this.slider.init()
    this.slider.slider?.slideTo(this.index, 0, false)
  }

  sliderClickHandler(evt) {
    const slider = this.slider?.slider

    if (!slider) {
      return
    }

    const halfWidth = window.innerWidth / 2

    evt.x > halfWidth
      ? slider.slideNext()
      : slider.slidePrev()
  }

  startSliderHandler() {
    if (!this.slider?.slider) {
      return
    }

    this.slider.slider.pagination.el.classList.remove('mentor-v3-modal__pagination--paused')
    this.slider.slider.autoplay.start()
  }

  stopSliderHandler() {
    if (!this.slider?.slider) {
      return
    }

    this.slider.slider.pagination.el.classList.add('mentor-v3-modal__pagination--paused')
    this.slider.slider.autoplay.stop()

    window.$analytics?.push('mentor-stop-slider', { id: this.slider.slider.activeIndex })
  }
}
